import React, { useState } from 'react';
import { useStringsContext } from '../../../contexts/strings';
import SocialComments from './social-comments-list';
import SocialReactions from './social-reactions-list';
import ScenePage from '../../common/scene/scene-page';

enum TABS {
  COMMENTS,
  REACTIONS,
}

interface Props {
  match: any; // TODO Fix type
}

function SocialInteractionScene({ match }: Props) {
  const { strings } = useStringsContext();
  const [selectedTab, setSelectedTab] = useState(TABS.COMMENTS);

  return (
    <ScenePage
      title={strings.appBar.socialInteractions}
      tabs={[strings.social.tabComments, strings.social.tabReactions]}
      selectedTab={selectedTab}
      onSelectedTab={setSelectedTab}
    >
      {selectedTab === TABS.COMMENTS && <SocialComments selectedAbbrv={match.params.abbrv} />}
      {selectedTab === TABS.REACTIONS && <SocialReactions selectedAbbrv={match.params.abbrv} />}
    </ScenePage>
  );
}

export default SocialInteractionScene;
